export default "__VITE_ASSET__DNKHXC5S__"